$(function() {

    var productFeed = $('#product-feed');
    var categoryFeed = $('#category-feed');

    productFeed.ajaxFilter({
        label: 'Enter the title of the product you would like to attach to this feed:',
        sortable: true,
        filterUrl: productFeed.attr( 'data-filter-url' ),
        addItemUrl: productFeed.attr( 'data-add-item-url' ),
        currentListUrl: productFeed.attr( 'data-current-list-url' ),
        removeItemUrl: productFeed.attr( 'data-remove-item-url' ),
        sortUrl: productFeed.attr( 'data-sort-url' ),
        tableColumns: [ 'id', 'name' ],
        extraQueryParameters: { pid: productFeed.attr( 'data-pid' ) },
        displayRow: function( item ) {
            return '#' + item.id + ' - ' + item.name;
        }
    });

    categoryFeed.ajaxFilter({
        label: 'Enter the title of the category you would like to attach to this feed:',
        sortable: true,
        filterUrl: categoryFeed.attr( 'data-filter-url' ),
        addItemUrl: categoryFeed.attr( 'data-add-item-url' ),
        currentListUrl: categoryFeed.attr( 'data-current-list-url' ),
        removeItemUrl: categoryFeed.attr( 'data-remove-item-url' ),
        sortUrl: categoryFeed.attr( 'data-sort-url' ),
        tableColumns: [ 'id', 'name' ],
        extraQueryParameters: { pid: categoryFeed.attr( 'data-pid' ) },
        displayRow: function( item ) {
            return '#' + item.id + ' - ' + item.name;
        }
    });

});
